module.exports = __webpack_public_path__ + "media/signup-react/Hide-e4f5100f.svg";